module.exports = __webpack_public_path__ + "img/KC.f708e320.png";